import { Injectable } from "@angular/core";
import { LoginResponse } from "@shared/schemas/complete-login";
import { LocalStorageService } from "./storage/local-storage.service";
import { AnalyticsBrowser } from "@segment/analytics-next";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth/auth.service";

export interface TrackInfo {
	screen: string;
	action: string;
	table: string;
	properties?: {
		[k: string]: unknown;
	};
}

@Injectable({
	providedIn: "root"
})
export class CustomSegmentService {
	private _analytics = AnalyticsBrowser.load({
		writeKey: environment.SEGMENT_API_KEY
	});

	constructor(
		private localStorage: LocalStorageService,
		private authService: AuthService
	) {}

	track(trackInfo: TrackInfo): void {
		if (this.authService.isSupportLoggedInAsNormalUser()) {
			return;
		}

		const userLogin = this.localStorage.get<LoginResponse>("userLogin");
		void this._analytics.track(trackInfo.table, {
			screen: trackInfo.screen,
			action: trackInfo.action,
			customer_persistence: userLogin?.idUnidadePersistencia,
			charge_type: "",
			properties: {
				...(trackInfo.properties || {}),
				app_version: environment.VERSION ?? "0.0.0"
			}
		});

		this.loginIdentify();
	}

	loginIdentify(): void {
		const userLogin = this.localStorage.get<LoginResponse>("userLogin");
		void this._analytics.identify(String(userLogin?.idUsuario), {
			customer_persistence: userLogin?.idUnidadePersistencia,
			email: userLogin?.email,
			username: userLogin?.nomeUsuario,
			charge_type: ""
		});
	}
}
